import classNames from "classnames";
import styles from "./Table.module.scss";
import { AddRemoveColumnIcon } from "@netapp/bxp-style/react-icons/Action";
import React from "react";

const ToggleColumnSelectorButton = ({ isActive, toggle, columnStickyStyleRef, className, style }) => {
    return <button type="button" onClick={toggle} style={style}
                   className={classNames(columnStickyStyleRef.current.dataset.styleid, styles['toggle-column-selector'], { [styles['active']]: isActive }, className)}>
        <AddRemoveColumnIcon/></button>
}

export default  ToggleColumnSelectorButton;